export default __webpack_public_path__ + "static/media/strategic.cfe05623.png";